module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('loader', {
    attrs: {
      "loading": _vm.isLoading
    }
  }) : _c('div', [_c('page-title', {
    attrs: {
      "title": "Detalhe",
      "image": _vm.module.logo
    }
  }), _vm._v(" "), _c('panel', [_c('div', {
    staticClass: "l-row"
  }, [(_vm.feed.externalCode) ? _c('div', {
    staticClass: "l-col-3@md"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('code.label')) + ":")]), _vm._v("\n            " + _vm._s(_vm.feed.externalCode) + "\n          ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "l-col-3@md"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t((_vm.identifier + ".feed.type.label"))) + ":")]), _vm._v("\n            " + _vm._s(_vm.$t((_vm.identifier + ".feed.type." + (_vm.feed.type) + ".label"))) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "l-col-3@md"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t((_vm.identifier + ".feed.created.label"))) + ":")]), _vm._v("\n            " + _vm._s(_vm._f("moment")(_vm.feed.created, 'DD/MM/YYYY HH:mm')) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "l-col-3@md"
  }, [_c('span', [_c('strong', [_vm._v("Status:")]), _vm._v(" "), _c('span', {
    staticClass: "badge",
    class: _vm.feed.status
  }, [_vm._v(_vm._s(_vm.$t((_vm.identifier + ".feed.statuses." + (_vm.feed.status) + ".label"))))])])]), _vm._v(" "), _c('div', {
    staticClass: "l-col-3@md"
  }, [_c('span', [_c('strong', [_vm._v("Em fila:")]), _vm._v(" "), _c('span', {
    staticClass: "badge queue"
  }, [_vm._v(_vm._s(_vm.$t((_vm.identifier + ".feed.queued." + (_vm.feed.queued) + ".label"))))])])]), _vm._v(" "), _c('div', {
    staticClass: "l-col-3@md"
  }, [_c('span', [_c('strong', [_vm._v("Envio:")]), _vm._v(" "), (_vm.feed.contentData) ? _c('button', {
    staticClass: "btnLink",
    on: {
      "click": function($event) {
        return _vm.downloadFeed('contentData')
      }
    }
  }, [_c('span', {
    staticClass: "hint hint--right",
    attrs: {
      "data-label": "Baixe aqui"
    }
  }, [_vm._v("\n                  Fazer download\n                ")]), _vm._v(" "), _c('i', {
    staticClass: "icon-file-download"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "l-col-3@md"
  }, [_c('span', [_c('strong', [_vm._v("Retorno:")]), _vm._v(" "), (_vm.feed.report) ? _c('button', {
    staticClass: "btnLink",
    on: {
      "click": function($event) {
        return _vm.downloadFeed('report')
      }
    }
  }, [_c('span', {
    staticClass: "hint hint--right",
    attrs: {
      "data-label": "Baixe aqui"
    }
  }, [_vm._v("\n                  Fazer download\n                ")]), _vm._v(" "), _c('i', {
    staticClass: "icon-file-download"
  })]) : _vm._e()])])])]), _vm._v(" "), _c('panel', {
    staticClass: "blue-panel",
    attrs: {
      "title": "Itens da carga"
    }
  }, _vm._l((_vm.feed.items), function(item) {
    return _c('panel', {
      key: item,
      attrs: {
        "title": ((item.code) + " - " + (item.description)),
        "withBody": false,
        "withFooter": false
      }
    })
  }), 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-da076d6c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Feed/Detail.vue
// module id = 3450
// module chunks = 0